import React from 'react'
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react'

export const GoogleMap: React.FC = () => {

  return (
    <iframe src="https://snazzymaps.com/embed/316937" width="100%" height="300px" style={{border:'none'}}></iframe>
  )
}